module.exports = __webpack_public_path__ + "images/54bb5fa1aca28c12fae105934a31f3d0-leadersclub-dark.png";